import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Table from "../../../../../../../../common/components/table-manager/v1.1/table";
import PageLoader from "../../../../../../../../components/PageLoader";
import { useAppDispatch } from "../../../../../../../../hooks/hooks";
import { useSelector } from "react-redux";
import { selectListItems } from "../../../../../../../../redux/library/selector";
import { selectDBAIncementalLogsListItems } from "../../../../../../../../redux/dba-incremental-logs/selector";
import { dbaIncementalLogs } from "../../../../../../../../redux/dba-incremental-logs/action";

const DBAIncrementalLogs = ({ selectedDba }: any) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const dbaIncrementalLogsListItems = useSelector(selectDBAIncementalLogsListItems)
  const libraryData = useSelector(selectListItems)
  const [columnDefs, setColumnDefs] = useState({});

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'TransactionId', headerName: 'Transaction Id', sortable: true, filter: true, filterType: 'text' },
      { field: 'BAPId', headerName: 'BAP Id', sortable: true, filter: true, filterType: 'text' },
      { field: 'IsStarted', headerName: 'Started', cellRenderer: 'yesNoRenderer' },
      { field: 'IsStoped', headerName: 'Stoped', cellRenderer: 'yesNoRenderer' },
      { field: 'IsCatalogUpdateCompleted', headerName: 'Resolved', cellRenderer: 'yesNoRenderer' },
      { field: 'Interval', headerName: 'Interval', sortable: true, filter: true, filterType: 'text' },
      { field: 'LastSentDateOnUtc', headerName: 'Last Sent Date On', isDateValueFormat: true, },
      { field: 'StartTimeOnUtc', headerName: 'Start Time On', isDateValueFormat: true, },
      { field: 'EndTimeOnUtc', headerName: 'End Time On', isDateValueFormat: true, }
    ]);
  }

  const fetchDBAIncrementalLogsList = async () => {
    await dispatch(dbaIncementalLogs.resetAction({ actionType: 'list' }))
    await dispatch(dbaIncementalLogs.list({
      url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/catalog/incremental-catalog-schedule/list`,
      entity: 'dbaIncementalLogs',
      jsonData:
      {
        PageNumber: pageData,
        PageSize: pageSize,
        SortField: "Id",
        SortOrder: "desc",
      }
    }))
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleReloadData = () => {
    fetchDBAIncrementalLogsList();
  };

  const handleSearch = async (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column || data?.searchCriteriaList,
        FieldText: data?.column || data?.searchCriteriaList,
        FieldType: 'text',
        FilterOperatorId: data?.filterOperatorId || 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    await dispatch(dbaIncementalLogs.resetAction({ actionType: 'list' }))
    await dispatch(dbaIncementalLogs.list({
      url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/catalog/incremental-catalog-schedule/list`,
      entity: 'dbaIncementalLogs',
      jsonData:
      {
        PageNumber: pageData,
        PageSize: pageSize,
        SortField: "Id",
        SortOrder: "desc",
        Searches: searchCriteria,
      }
    }));
  }

  useEffect(() => {
    createColumnDefs();
    fetchDBAIncrementalLogsList();
  }, [pageData, pageSize])

  return (
    <>
      {dbaIncrementalLogsListItems?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          rowData={dbaIncrementalLogsListItems?.result?.items}
          setPageData={setPageData} setPageSize={setPageSize}
          paginationData={dbaIncrementalLogsListItems?.result?.pagination}
          enableFilter={true} onSearch={handleSearch}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          additionButtons={additionButtons}
          headingName="DBA Incremental Logs"
        />
      }
    </>
  );
};

export default DBAIncrementalLogs;


